import { render, staticRenderFns } from "./DeliveredMail.vue?vue&type=template&id=1c36ffe2"
import script from "./DeliveredMail.vue?vue&type=script&lang=js"
export * from "./DeliveredMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports